module.exports = __webpack_public_path__ + "998ed16c1b5eb831bb39be33cd1d6362.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-768.webp.png
// module id = 383
// module chunks = 0